module.exports = __webpack_public_path__ + "static/media/elaf2.55ddc6c0.jpeg";